import { GetStaticProps } from 'next'
import { withPasswordProtect } from 'next-password-protect'

import { WEBSITE_LOCALES, WebsiteLocale } from 'types/locales'

import { getHomePageContent } from '@/graphql/Homepage'
import { getAllModularLandingPages, getModularLandingPageBySlug } from '@/graphql/ModularLandingPage'

import { Homepage } from '@/components/pages/homepage/Homepage'
import { ModularLandingPage } from '@/components/pages/modular-landing/ModularLandingPage'

export const getStaticProps: GetStaticProps = async ({ params, preview }) => {
  const localeOrSlug = params?.locale as string

  if (WEBSITE_LOCALES.includes(localeOrSlug as WebsiteLocale)) {
    const page = await getHomePageContent(!!preview, localeOrSlug as WebsiteLocale)
    if (page) {
      return { props: { page, locale: localeOrSlug } }
    }
    throw new Error('No Homepage content found')
  }

  // Otherwise, show the modular landing page
  const page = await getModularLandingPageBySlug(localeOrSlug, preview)
  if (page) {
    return { props: { page, slug: localeOrSlug } }
  }

  return {
    notFound: true,
  }
}

export async function getStaticPaths() {
  const paths: { params: { locale: string } }[] = []

  // Add homepage paths for each locale
  WEBSITE_LOCALES.forEach((locale) => {
    paths.push({ params: { locale } })
  })

  // Add modular landing page paths without locale
  const modularLandingPages = await getAllModularLandingPages()
  modularLandingPages.forEach((modularPage: { slug: string }) => {
    paths.push({ params: { locale: modularPage.slug.toString() } })
  })

  return {
    paths,
    fallback: false,
  }
}

function ProtectedOrNotPage(props) {
  if (props.page?.passwordProtected) {
    const ProtectedPage = withPasswordProtect(ModularLandingPage)
    return <ProtectedPage {...props} />
  }
  return props.slug ? <ModularLandingPage {...props} /> : <Homepage {...props} />
}

export default ProtectedOrNotPage
